import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { SnackbarProvider } from "notistack";

if (/Win/i.test(navigator.platform) || /Windows/i.test(navigator.userAgent)) {
  document.body.classList.add("windows-os");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <GoogleOAuthProvider
      clientId={window.env.REACT_APP_GOOGLE_CLIENT_ID || "bla bla bla"}
    >
      <SnackbarProvider maxSnack={3}>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </SnackbarProvider>
    </GoogleOAuthProvider>
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
